// removed by extract-text-webpack-plugin
module.exports = {"nav-item":"NavItem__nav-item__PIurN","dropdown":"NavItem__dropdown__1Fyjc","child":"NavItem__child__1w_77"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Mobile/NavItem/NavItem.scss
// module id = 699
// module chunks = 0